import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';

export const StyledContainer = styled.div`
  padding: 1.5rem;
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1rem;

  .ant-btn .anticon {
    ${pickThemeFontStyles('18', '24')};
  }
`;
